const {version} = require('../../../package.json');

export enum EnnablEnv {
  development = 'development',
  production = 'production',
}

export const ENV_DEV_URL = 'https://dev.ennabl-test.com';

export const MIN_ALLOWED_YEAR = 1900;

export const APP_VERSION = version;

export const NO_VALUE_CELL = '–';

export const IS_TOUCH_DEVICE = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

export const INTERMEDIARY_EMPTY = 'Intermediary - Empty';
export const ACCOUNT_MANAGER_EMPTY = 'Account Manager - Empty';
export const ACCOUNT_MANAGER_FALLBACK_ID = 'account-manager-';

export const PRODUCER_EMPTY = 'Producer - Empty';
export const PRODUCER_FALLBACK_ID = 'producer-';
export const EMPTY_ID_SUFFIX = 'dummy-id-';

export const ACCOUNT_EXECUTIVE_EMPTY = 'Account executive - Empty';
export const ACCOUNT_EXECUTIVE_FALLBACK_ID = 'account-executive-';

export const RETAIL_AGENCY_EMPTY = 'Agency - Empty';
export const RETAIL_AGENCY_FALLBACK_ID = 'agency-';

export const RETAIL_SPECIALIST_EMPTY = 'Agency Producer - Empty';
export const RETAIL_SPECIALIST_FALLBACK_ID = 'specialist-';
